export default "__VITE_ASSET__70386810__"